import './InfoBanner.scss';

import { cva, VariantProps } from 'class-variance-authority';
import classNames from 'classnames';
import { ReactElement } from 'react';

import Body from '../Body';
import Button from '../Button';
import { ButtonProps } from '../Button/Button';
import { CtaButtons } from '../CtaButtons/CtaButtons';
import Title from '../Title';

type Props = {
  Title: ReactElement<typeof Title>;
  Body: ReactElement<typeof Body>;
  PrimaryCta?: ReactElement<ButtonProps, typeof Button>;
  SecondaryCta?: ReactElement<ButtonProps, typeof Button>;
} & VariantProps<typeof placementVariance>;

const className = 'c-InfoBanner';

const placementVariance = cva(className, {
  variants: {
    titlePlacement: {
      left: `${className}--title-left`,
      right: `${className}--title-right`,
    },
  },
  defaultVariants: {
    titlePlacement: 'left',
  },
});

export const InfoBanner = ({
  Title,
  titlePlacement,
  Body,
  PrimaryCta,
  SecondaryCta,
}: Props) => {
  return (
    <section
      role="banner"
      className={classNames(placementVariance({ titlePlacement }))}
    >
      <div className={`${className}__title`}>{Title}</div>
      <div className={`${className}__content`}>
        <div>{Body}</div>
        <CtaButtons PrimaryCta={PrimaryCta} SecondaryCta={SecondaryCta} />
      </div>
    </section>
  );
};
